module.exports = __webpack_public_path__ + "static/media/SmartMachines_EN.21a6dd8e.png";